import actionTypes from '../constants/action-types';

const initialState = {
  visibility: false,
};

const mainMenu = (state = initialState, action) => {
  if (action.type === actionTypes.SHOW) {
    return {
      ...state,
      visibility: true,
    };
  }

  if (action.type === actionTypes.HIDE) {
    return {
      ...state,
      visibility: false,
    };
  }

  return state;
};

export default mainMenu;
